/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsCompanyPaymentsOutput } from "../../entities/models/CompanyPaymentsOutput";
import { modelsCompanyPaymentOutputSchema } from "./companyPaymentOutputSchema";
import { z } from "zod/v4";

export const modelsCompanyPaymentsOutputSchema = z.object({
    get "items"(){
                return z.array(modelsCompanyPaymentOutputSchema).optional()
              },
"limit": z.optional(z.int()),
"offset": z.optional(z.int()),
"total": z.optional(z.int())
    }) as unknown as z.ZodType<ModelsCompanyPaymentsOutput>